module.exports = __webpack_public_path__ + "img/Paladin-dwarf-m-70.a335286c.gif";